<template>
  <a :href="message.url"
     class="tw:block tw:rounded-lg tw:border tw:border-zinc-300 tw:bg-white tw:text-inherit tw:no-underline tw:hover:border-zinc-500 tw:hover:no-underline">
    <div data-anchor class="tw:flex tw:items-center tw:gap-2 tw:px-2.5 tw:py-2 tw:text-sm tw:font-medium tw:text-zinc-900">
      <span class="tw:flex tw:size-5.5 tw:shrink-0 tw:items-center tw:justify-center tw:rounded-md tw:bg-teal-600 tw:text-white"
            aria-hidden="true">
        <component :is="icon" class="tw:size-3.5" />
      </span>
      <span class="tw:truncate">{{ message.name }}</span>
    </div>
    <dl class="tw:m-0 tw:border-t tw:border-zinc-200 tw:px-2.5 tw:py-1.5 tw:text-xs tw:leading-6 tw:text-zinc-500">
      <div v-if="message.timing" class="tw:flex tw:justify-between tw:gap-2">
        <dt class="tw:font-normal">{{ $t(message.type === 'scheduled' ? 'Sent on' : 'Sending') }}</dt>
        <dd class="tw:m-0 tw:text-zinc-900">{{ message.timing }}</dd>
      </div>
      <div v-if="message.sent_count > 0" class="tw:flex tw:justify-between tw:gap-2">
        <dt class="tw:font-normal">{{ $t('Sent') }}</dt>
        <dd class="tw:m-0 tw:text-zinc-900">{{ message.sent_count }}</dd>
      </div>
      <div class="tw:flex tw:justify-between tw:gap-2">
        <dt class="tw:font-normal">{{ $t('Status') }}</dt>
        <dd class="tw:m-0 tw:flex tw:items-center tw:gap-1.5 tw:text-zinc-900">
          <span class="tw:size-1.5 tw:rounded-full" :class="message.status === 'draft' ? 'tw:bg-zinc-400' : 'tw:bg-emerald-500'"
                aria-hidden="true"></span>
          {{ message.status_label }}
        </dd>
      </div>
    </dl>
  </a>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { CalendarClock, Hand, Mail } from '@lucide/vue'
import type { BoardMessage } from './types'

const props = defineProps<{
  message: BoardMessage;
}>()

const icon = computed(() => ({
  automatic: Mail,
  scheduled: CalendarClock,
  manual: Hand,
})[props.message.type])
</script>
